export const formatFactor = (factor: string) => {
  const formated = factor.replace('_', ' ');
  return formated.charAt(0).toUpperCase() + formated.slice(1);
};
